"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var kotlin_1 = __importDefault(require("kotlin"));
/**************************** MONKEY PATCHING JAVA-REQUIRED FUNCTIONS *****************************/
/**
 * True if array is empty
 */
Array.prototype.isEmpty = function () {
    return this.length < 1;
};
/**
 * Augment Arrays with includes, contains, contains_11rb$, & addEntries functions
 */
addIncludesPolyfills();
addEntriesPolyfill();
addArrayAddPolyfills();
addArraySetPolyfills();
addArrayRemovePolyfills();
getArrayAddPolyfills();
clearArrayAddPolyfills();
/**
 * Adds add & add_11rb$ functions to Array.prototype
 * These act the same as push
 */
function addArrayAddPolyfills() {
    function add(val) {
        return this.push(val);
    }
    ["add", "add_11rb$"].forEach(function (alias) {
        if (!Array.prototype[alias]) {
            Object.defineProperty(Array.prototype, alias, { value: add });
        }
    });
}
/**
 * Adds get & get_za3lpa$ functions to Array.prototype
 */
function getArrayAddPolyfills() {
    function get(val) {
        return this[val];
    }
    ["get", "get_za3lpa$"].forEach(function (alias) {
        if (!Array.prototype[alias]) {
            Object.defineProperty(Array.prototype, alias, { value: get });
        }
    });
}
/**
 * Adds clear function to Array.prototype
 */
function clearArrayAddPolyfills() {
    function clear() {
        // https://stackoverflow.com/questions/1232040/how-do-i-empty-an-array-in-javascript
        this.length = 0;
    }
    ["clear"].forEach(function (alias) {
        if (!Array.prototype[alias]) {
            Object.defineProperty(Array.prototype, alias, { value: clear });
        }
    });
}
/**
 * Adds remove & remove_11rb$ functions to Array.prototype
 * These remove matching values
 */
function addArrayRemovePolyfills() {
    function remove(val) {
        var valProto = Object.getPrototypeOf(val);
        var thisProto = Object.getPrototypeOf(this);
        if (valProto !== thisProto)
            return;
        var matchIndex = this.findIndex(function (v) { return v === val; });
        if (matchIndex !== -1)
            return this.splice(matchIndex, 1);
    }
    ["remove", "remove_11rb$"].forEach(function (alias) {
        if (!Array.prototype[alias]) {
            Object.defineProperty(Array.prototype, alias, {
                value: remove,
                configurable: false,
                writable: true,
            });
        }
    });
}
/**
 * Adds set & set_wxm5ur$ to Array.prototype
 * These set a value at a given index
 */
function addArraySetPolyfills() {
    ["set", "set_wxm5ur$"].forEach(function (alias) {
        if (!Array.prototype[alias]) {
            Array.prototype[alias] = function (idxToSet, newVal) {
                // Throw if setting invalid position
                if (idxToSet < 0 || idxToSet >= this.length) {
                    throw new Error("Array#set error: index " + idxToSet + " is out of bounds. Array is of length " +
                        (this.length + " - cannot set " + newVal + " at position above current length"));
                }
                var origVal = this[idxToSet];
                this[idxToSet] = newVal;
                return origVal;
            };
        }
    });
}
/**
 * Adds includes, contains, & contains_11rb$ functions to Array.prototype (if
 * not already present)
 */
function addIncludesPolyfills() {
    function includes(searchElement, fromIndex) {
        if (this == null)
            throw new TypeError("\"this\" is null or not defined");
        var o = Object(this);
        var len = o.length >>> 0;
        if (len === 0)
            return false;
        var n = fromIndex | 0;
        var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
        var sameValueZero = function (x, y) {
            return x === y || (typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y));
        };
        while (k < len) {
            if (sameValueZero(o[k], searchElement))
                return true;
            k++;
        }
        return false;
    }
    ["includes", "contains", "contains_11rb$"].forEach(function (alias) {
        if (!Array.prototype[alias]) {
            Object.defineProperty(Array.prototype, alias, { value: includes });
        }
    });
}
/**
 * Add entries function to global Object prototype (if not already present)
 */
function addEntriesPolyfill() {
    if (!Object["entries"]) {
        Object.defineProperty(Object, "entries", {
            value: function entries(obj) {
                var ownProps = Object.keys(obj);
                var i = ownProps.length;
                var resArray = new Array(i); // preallocate the Array
                while (i--)
                    resArray[i] = [ownProps[i], obj[ownProps[i]]];
                return resArray;
            },
        });
    }
}
/******************* ADD OVERRIDE FOR ITERATORS (TO ALLOW IT TO WORK WITH JAVA) *******************/
// prettier-ignore
Array.prototype["iterator"] = function iterator() {
    var _this = this;
    var curPos = 0;
    var clear = function () { while (hasNext())
        next(); };
    var remove = function () { hasNext() && next(); };
    var hasNext = function () { return curPos < _this.length; };
    var next = function () { return hasNext() ? _this[curPos++] : undefined; };
    var peek = function () { return hasNext() ? _this[curPos + 1] : undefined; };
    var size = function () { return _this.length; };
    var position = function () { return curPos; };
    var remaining = function () { return _this.length - curPos; };
    return { next: next, hasNext: hasNext, clear: clear, remove: remove, peek: peek, size: size, position: position };
};
/********************************** NUMBER EXTENSIONS/POLYFILLS ***********************************/
/**
 * Ensures Kotlin can transpile operator overloaded numbers
 * Provides subtraction functionality (returns duplicate of current number with
 * given number subtracted from it)
 */
Number.prototype["subtract"] = function subtract(numToSubtract) {
    return new Number(this - numToSubtract);
};
Number.prototype["add"] = function add(numToAdd) {
    return new Number(this + numToAdd);
};
["compareTo", "compareTo_11rb$"].forEach(function (compareToKey) {
    Number.prototype[compareToKey] = function compareTo(comparisonNum) {
        return this < comparisonNum ? -1 : this > comparisonNum ? 1 : 0;
    };
});
Number.prototype["unaryMinus"] = function unaryMinus() {
    return new Number(this * -1);
};
Number.prototype["unaryPlus"] = function unaryMinus() {
    return new Number(this);
};
Number.prototype["toNumber"] = function toNumber() {
    return new Number(this);
};
/*********************** REGULAR EXPRESSION EXTENSIONS (REQUIRED BY KOTLIN) ***********************/
kotlin_1.default.kotlin.text.Regex_init_61zpoe$ = function Regex_init(str) {
    return new RegExp(str);
};
/**
 * Returns true if regex matches the entire input string
 */
RegExp.prototype["matches"] = RegExp.prototype["matches_6bul2c$"] = function matches(str) {
    var newFlags = "g" + this.flags.replace("g", "");
    var newRegex = new RegExp(this.source, newFlags);
    var matches = str.match(newRegex);
    return matches && matches.length > 0 && matches[0] === str;
};
/**
 * Indicates whether the regular expression can find at least one match in the
 * specified input string
 */
RegExp.prototype["containsMatchIn"] = RegExp.prototype["containsMatchIn_6bul2c$"] = function containsMatchIn(str) {
    return !!str.match(this);
};
/**
 * Replaces all occurrences of this regular expression in the specified input
 * string with specified replacement expression
 */
RegExp.prototype["replace"] = RegExp.prototype["replace_x2uqeu$"] = function replace(str, replaceValue) {
    return str.replace(this, replaceValue);
};
//# sourceMappingURL=polyfills.js.map